export const dedup = (array: any[]) => [...new Set(array)];
